// React
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Accordion from '@stubhub/react-accordion';
import FormattedLink from '@stubhub/react-formatted-link';
import SEOJSONLDElement from '../react-sell-seo-jsonld';
import FaqTemplate from './faq-templates';

// Utils
import {FAQ_SCHEMA} from './faq-templates/json-ld-schema';
import {FAQ_HEADERS} from './faq-templates/faq-headers';
import {getHelpLink} from '../react-sell-merch-header/src/nav-config';

// Translations
import {FormattedMessage} from 'react-intl';
import {FAQ_MESSAGES} from "./faq-templates/faq-messages";

// Styles
import './styles.scss';

const SellFAQ = ({shstoreId, lang}) => {
  const FAQ_ACCORDION_ITEMS = FAQ_SCHEMA.mainEntity.map(
    (entity, index) => {
      const FAQ = `Faq${index + 1}`;
      return (
        {
          id: FAQ,
          head: <FormattedMessage {...FAQ_HEADERS[FAQ]}/>,
          body: <FaqTemplate faqSrc={FAQ_MESSAGES} faqMessage={FAQ}/>
        }
      );
    }
  );
  const helpURL = getHelpLink(shstoreId, lang);
  return (
    <div className={'Sell_FAQ'}>
      <SEOJSONLDElement jsonld={JSON.stringify(FAQ_SCHEMA)}/>
      <div className={'Sell_FAQ-title'}>
        <FormattedMessage id="Sell.Faq.title" defaultMessage="Selling FAQ"/>
      </div>
      <Accordion items={FAQ_ACCORDION_ITEMS} activeItem={'Faq1'}/>
      <FormattedLink
        className='Sell_FAQ-button'
        href={helpURL}
        target={"_blank"}>
        <FormattedMessage id="Sell.Faq.button" defaultMessage="More"/>
      </FormattedLink>
    </div>
  );
};

SellFAQ.propTypes = {
  shstoreId: PropTypes.number,
  lang: PropTypes.string
};

export default SellFAQ;
